module.exports = __webpack_public_path__ + "static/media/love-icon-hollow.3067bdf2.svg";